function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import mergeContextVariables from './mergeContextVariables';
export default function wrapOptionsWithCache(options, v1Context) {
    if (!options.update) {
        return options;
    }
    const originalUpdate = options.update;
    return _object_spread_props(_object_spread({}, options), {
        update: (cache, result)=>{
            return originalUpdate(wrapCache(cache, v1Context), result);
        }
    });
}
export function wrapCache(cache, v1Context) {
    return {
        evict: (object)=>cache.evict(object),
        gc: ()=>cache.gc(),
        identify: (object)=>cache.identify(object),
        modify: (options)=>cache.modify(options),
        readQuery: ({ query, variables })=>{
            return cache.readQuery({
                query,
                variables: _object_spread_props(_object_spread({}, variables), {
                    v1Context: mergeContextVariables(v1Context, variables === null || variables === void 0 ? void 0 : variables.v1Context)
                })
            });
        },
        writeQuery: ({ query, variables, data })=>{
            return cache.writeQuery({
                query,
                variables: _object_spread_props(_object_spread({}, variables), {
                    v1Context: mergeContextVariables(v1Context, variables === null || variables === void 0 ? void 0 : variables.v1Context)
                }),
                data
            });
        }
    };
}

//# sourceMappingURL=wrapOptionsWithCache.js.map